import path from 'path';

// test.png -> png
export const getFileExtension = (filename: string) => path.extname(filename).substring(1);
export const getFileBaseName = (filename: string) =>
  path.basename(filename, path.extname(filename));
